module.exports = __webpack_public_path__ + "assets/media/list-connector.7887598f.svg";